import { ItemViewModel } from './item.view-model';
import { Item } from '../../domain-models/main/item';
import { CollectionViewModel, ItemViewModelTypeDecorator } from '@nts/std';
import type { DomainModelCollectionInterface } from '@nts/std/interfaces';
import { ItemIdentity } from '../../domain-models/main/item.identity';

@ItemViewModelTypeDecorator(ItemViewModel)
export class ItemCollectionViewModel extends CollectionViewModel<ItemViewModel, Item, ItemIdentity> {

    constructor() {
        super();

        // Typescript 2.1 BREAKING CHANGE
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ItemCollectionViewModel.prototype);
    }

    async addForTesting() {
        await this.addNew();
    }

    getEntityCollectionForTesting(): DomainModelCollectionInterface<ItemIdentity, Item> {
        return this.collection;
    }

    removeForTesting(index: number) {
        this.remove(index);
    }

}
